import { z } from 'zod';
import { API_KEY_SCOPES } from '../constants';

export const createApiKeySchema = z.object({
  companyId: z.string().uuid(),
  /** Nombre visible de la cuenta de servicio (p. ej. "Multiagente WhatsApp"). */
  name: z.string().trim().min(3).max(80),
  /** Usuario BOT existente al que se asocia; si no se envía, se crea uno con ese nombre. */
  userId: z.string().uuid().optional(),
  /** Permisos de la clave; por defecto todos. */
  scopes: z
    .array(z.enum(API_KEY_SCOPES))
    .min(1, 'Elige al menos un permiso')
    .default([...API_KEY_SCOPES]),
  /** Caducidad obligatoria: si no se envía, un año desde la creación (máximo 2 años). */
  expiresAt: z.coerce
    .date()
    .refine((d) => d.getTime() > Date.now(), 'La caducidad debe ser futura')
    .refine((d) => d.getTime() <= Date.now() + 2 * 366 * 86_400_000, 'Máximo 2 años de vigencia')
    .optional()
    .nullable(),
});
export type CreateApiKeyInput = z.infer<typeof createApiKeySchema>;
export type CreateApiKeyPayload = z.input<typeof createApiKeySchema>;

/** Rotación: nueva clave para la misma cuenta BOT (mismos permisos salvo que se indiquen); la anterior se revoca. */
export const rotateApiKeySchema = z.object({
  scopes: z.array(z.enum(API_KEY_SCOPES)).min(1).optional(),
  expiresAt: z.coerce.date().optional().nullable(),
});
export type RotateApiKeyInput = z.infer<typeof rotateApiKeySchema>;
